import { OFFLINE_STATUS } from '../../services/offlineService';

/**
 * Shared offline utility helpers.
 */

/**
 * @param {Record<string, any> | null | undefined} locationState
 * @returns {string | null}
 */
export function getOfflinePatientId(locationState) {
  return locationState?.offlinePatientId ?? null;
}

/**
 * @param {Record<string, any> | null | undefined} locationState
 * @returns {boolean}
 */
export function isOfflineView(locationState) {
  return !!getOfflinePatientId(locationState);
}

/**
 * @param {{
 *   offlinePatientId: string,
 *   setIsDemoUser: (value: boolean) => void,
 *   setIsDemoOffline: (value: boolean) => void,
 *   setUserId: (value: string | null) => void,
 *   setPatientId: (patientId: string) => void,
 *   setPatientResolved: (resolved: boolean) => void,
 *   setAuthChecked: (checked: boolean) => void,
 * }} args
 */
export function applyOfflineViewState({
  offlinePatientId,
  setIsDemoUser,
  setIsDemoOffline,
  setUserId,
  setPatientId,
  setPatientResolved,
  setAuthChecked,
}) {
  setIsDemoUser(true);
  setIsDemoOffline(true);
  setUserId('demo');
  setPatientId(offlinePatientId);
  setPatientResolved(true);
  setAuthChecked(true);
}

/**
 * @param {string | null | undefined} url
 * @param {{ current: string[] }} createdBlobUrlsRef
 * @returns {string | null}
 */
export function trackBlobUrl(url, createdBlobUrlsRef) {
  if (url && url.startsWith('blob:')) {
    createdBlobUrlsRef.current.push(url);
  }
  return url ?? null;
}

/**

/**
 * @param {string | undefined | null} displayName
 * @param {number | undefined | null} createdTime
 * @returns {{displayName: string, createdTime: number} | undefined}
 */
export function createOfflinePatientMetadata(displayName, createdTime) {
  return displayName != null
    ? { displayName, createdTime: createdTime ?? 0 }
    : undefined;
}

/**
 * @param {import('react').Dispatch<import('react').SetStateAction<any>>} setOfflineStatus
 * @param {import('react').Dispatch<import('react').SetStateAction<number>>} setDownloadPercent
 * @param {import('react').Dispatch<import('react').SetStateAction<boolean>>} setDownloadError
 */
export function resetOfflineDownloadState(setOfflineStatus, setDownloadPercent, setDownloadError) {
  setOfflineStatus(OFFLINE_STATUS.IDLE);
  setDownloadPercent(0);
  setDownloadError(false);
}
